<template>
  <sa-page-layout :btnNewVisible="btnNewVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
    <template slot="table-body">
      <graffidi-device-list-component ref="GraffidiDeviceListComponent" @afterLoadData="onAfterLoadData"></graffidi-device-list-component>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import GraffidiDeviceListComponent from "../components/GraffidiDeviceListComponent.vue";

export default {
  components: { SaPageLayout, GraffidiDeviceListComponent },
  data() {
    return {
      btnNewVisible: true,
      pathResource: "",
      linkedit: "/graffididevice",
      showModalLoading: false,
      listKey: 0,
    };
  },
  mounted() {
    let me = this;
    me.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      me.showModalLoading = true;
      me.$refs.GraffidiDeviceListComponent.loadData();
    },
    onRefresh() {
      let me = this;
      me.loadData();
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
  },
};
</script>

<style></style>
